module.exports = __webpack_public_path__ + "media/header-image.e69271e6.mp4";